class SolevaProductLanding {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-gallery-track]');
    this.slides = [...root.querySelectorAll('[data-gallery-slide]')];
    this.thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    this.dots = [...root.querySelectorAll('[data-gallery-dot]')];
    this.mainForm = root.querySelector('[data-main-product-form]');
    this.mainButton = root.querySelector('[data-main-add]');
    this.sticky = root.querySelector('[data-sticky-cart]');
    this.bindGallery();
    this.bindBundles();
    this.bindVariants();
    this.bindSticky();
  }
  setActive(index) {
    this.thumbs.forEach((item, i) => item.classList.toggle('is-active', i === index));
    this.dots.forEach((item, i) => item.classList.toggle('is-active', i === index));
  }
  bindGallery() {
    this.thumbs.forEach((button, index) => button.addEventListener('click', () => {
      this.track?.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(index);
    }));
    if (!this.track || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) this.setActive(Number(visible.target.dataset.gallerySlide));
    }, { root: this.track, threshold: [.55, .8] });
    this.slides.forEach((slide) => observer.observe(slide));
  }
  bindBundles() {
    const input = this.root.querySelector('[data-quantity-input]');
    const options = [...this.root.querySelectorAll('[data-bundle-option]')];
    if (!input || !options.length) return;
    const sync = (option) => {
      const radio = option.querySelector('[data-bundle-quantity]');
      if (!radio) return;
      input.value = radio.dataset.bundleQuantity;
      options.forEach((item) => item.classList.toggle('is-selected', item === option));
      const stickyQuantity = this.root.querySelector('[data-sticky-quantity]');
      const stickyPrice = this.root.querySelector('[data-sticky-price]');
      if (stickyQuantity) stickyQuantity.value = input.value;
      if (stickyPrice && option.dataset.bundleTotal) stickyPrice.textContent = option.dataset.bundleTotal;
    };
    options.forEach((option) => option.querySelector('input[type="radio"]')?.addEventListener('change', () => sync(option)));
    sync(options.find((option) => option.querySelector('input[type="radio"]')?.checked) || options[0]);
  }
  bindVariants() {
    const select = this.root.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const stickyVariant = this.root.querySelector('[data-sticky-variant]');
      if (stickyVariant) stickyVariant.value = option.value;
    });
  }
  bindSticky() {
    if (!this.mainButton || !this.sticky || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.sticky.classList.toggle('is-visible', show);
      this.sticky.setAttribute('aria-hidden', String(!show));
    }, { threshold: .15 });
    observer.observe(this.mainButton);
  }
}

const initSolevaProductLanding = (scope = document) => {
  scope.querySelectorAll('[data-soleva-product]:not([data-initialized])').forEach((root) => {
    root.dataset.initialized = 'true';
    new SolevaProductLanding(root);
  });
};
document.addEventListener('DOMContentLoaded', () => initSolevaProductLanding());
document.addEventListener('shopify:section:load', (event) => initSolevaProductLanding(event.target));
